import { ValidationError } from "../../Common/types";

export default class HttpError extends Error {
    public statusCode: number;
    public body: any;
    public alreadyTranslated: boolean = false;
    public validationErrors?: ValidationError[];

    constructor(msg: string, statusCode: number, body: any = null) {
        super(msg);
        this.statusCode = statusCode;
        this.body = body;
    }
}
